<template>
  <section class="sidebar__nav" style="overflow: auto">
    <div class="icon-bar">
      <router-link to="/" class="waves-effect">
        <i class="fa fa-lightbulb-o" style="color: #fff"></i>
        Electricity
      </router-link>
      <router-link to="/airtime" class="waves-effect">
        <i class="fa fa-mobile"></i> Airtime
      </router-link>
      <router-link to="/data" class="waves-effect">
        <i class="fa fa-globe"></i> Data
      </router-link>
      <router-link to="/tv" class="waves-effect">
        <i class="fa fa-tv"></i>
        TV
      </router-link>
        <!-- <router-link to="/get_my_account" class="waves-effect">
        <i class="fa fa-user"></i> Get My Account
      </router-link> -->
      <router-link to="/transaction" class="waves-effect" v-if="userType == 1">
        <i class="fa fa-history"></i>
        Transaction History
      </router-link>
      <router-link
        to="/irecharge_pay"
        class="waves-effect"
        v-if="userType != 1"
      >
        <i class="fa fa-credit-card"></i>
        iRecharge <br />
        Pay
      </router-link>
      <a
        href="/more"
        class="waves-effect"
        :class="[
          this.$route.path == '/about' ||
          this.$route.path == '/terms-and-condition' ||
          this.$route.path == '/request_token' ||
          this.$route.path == '/mobile_money' ||
          this.$route.path == '/irecharge_merchant' ||
          this.$route.path == '/irecharge_corporate' ||
          this.$route.path == '/irecharge_api' ||
          this.$route.path == '/irecharge_perks' ||
          this.$route.path == '/irecharge_plus'
            ? 'router-link-exact-active router-link-active'
            : ''
        ]"
        @click.prevent="showMore"
      >
        <i class="fa fa-ellipsis-h"></i> More
      </a>
    </div>
  </section>
</template>
<script>
export default {
  mounted() {
    this.getUserType()
  },
  data() {
    return {
      userType: ''
    }
  },
  methods: {
    showMore() {
      $('.bills__side__wrapper').toggleClass('left_out')
    },
    getUserType() {
      this.userType = localStorage.getItem('userType')
    }
  }
}
</script>
